/* =============================================
   MIRATOKI — theme interactions
   ============================================= */
(function () {
  'use strict';

  /* Accordion (FAQ + product Q&A) — event delegation so it works
     inside Shopify page bodies and section markup alike. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion-item__trigger');
    if (!trigger) return;
    var item = trigger.closest('.accordion-item');
    if (item) item.classList.toggle('is-open');
  });

  /* Collection tabs on the homepage */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.collection-tab');
    if (!tab) return;
    var panelId = tab.getAttribute('data-panel');
    if (!panelId) return;
    var scope = tab.closest('.collection-tabs-scope') || document;
    scope.querySelectorAll('.collection-tab').forEach(function (t) {
      t.classList.remove('is-active');
    });
    scope.querySelectorAll('.collection-panel').forEach(function (p) {
      p.classList.remove('is-active');
    });
    tab.classList.add('is-active');
    var panel = scope.querySelector('#panel-' + panelId);
    if (panel) panel.classList.add('is-active');
  });

  /* Quantity stepper on product pages */
  window.mtUpdateQty = function (delta) {
    var input = document.getElementById('qty');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = Math.max(1, val + delta);
    input.value = val;
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    window.mtUpdateQty(parseInt(btn.getAttribute('data-qty-step'), 10) || 0);
  });

  /* Product gallery — click a thumb to swap the main image.
     The main image is rendered with srcset/sizes (responsive), and a
     browser ignores `src` while a srcset is present — so the srcset and
     sizes attributes must be replaced too, or the image never changes. */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pdp-gallery__thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.pdp-gallery');
    if (!gallery) return;
    var main = gallery.querySelector('.pdp-gallery__main');
    var src = thumb.getAttribute('data-full');
    if (main && src) {
      var img = main.querySelector('img');
      var thumbImg = thumb.querySelector('img');
      var alt = thumbImg ? (thumbImg.getAttribute('alt') || '') : '';
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        if (alt) img.alt = alt;
      } else {
        main.innerHTML = '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '">';
      }
    }
    gallery.querySelectorAll('.pdp-gallery__thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  /* Mobile navigation toggle */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.nav-toggle');
    if (!toggle) return;
    var nav = document.querySelector('.mobile-nav');
    if (nav) nav.classList.toggle('is-open');
  });
})();
